
// @ts-nocheck

if (!('getAttributeNames' in document.documentElement)) {
    // @ts-ignore
    Element.prototype.getAttributeNames = function getAttributeNames() {
        return Array.prototype.map.call(this.attributes, function(a) {
            return a.name;
        });
    };
}

// Android 4.2.2

// from: https://github.com/jserz/js_piece/blob/master/DOM/ChildNode/replaceWith()/replaceWith().md
(function (arr) {
    arr.forEach(function (item) {
      if (item.hasOwnProperty('replaceWith')) {
        return;
      }
      Object.defineProperty(item, 'replaceWith', {
        configurable: true,
        enumerable: true,
        writable: true,
        value: function replaceWith() {
          var argArr = Array.prototype.slice.call(arguments),
            docFrag = document.createDocumentFragment();
          
          argArr.forEach(function (argItem) {
            var isNode = argItem instanceof Node;
            docFrag.appendChild(isNode ? argItem : document.createTextNode(String(argItem)));
          });
          
          this.parentNode.replaceChild(docFrag, this);
        }
      });
    });
  })([Element.prototype, CharacterData.prototype, DocumentType.prototype]);


